import PropTypes from 'prop-types';
import React from 'react';
import { withTranslation } from 'react-i18next';

import './styles/LoadingIndicator.scss';
import Cycle from '../icon/Cycle';


export class LoadingIndicator extends React.Component {
	constructor(props, context) {
		super(props, context)
		this.state = {
		};
	}


	render() {
		const { i18n, iconCls, text, hasLoadingText = true } = this.props;
		const icon = iconCls ? [iconCls] : ['cycle'];
		const loadingText = text;
		return (
			<div className='loading-container'>
				<h1 className="loading-text display-3 text-center">
					<i className={`icon spin icon-${icon}`}>
						<Cycle />
					</i>
					{hasLoadingText && <span className='mx-1'>{i18n.t(loadingText)}</span>}
				</h1>
			</div>
		);
	}

}

LoadingIndicator.propTypes = {
	i18n: PropTypes.shape({}).isRequired,
	text: PropTypes.string,
	iconCls: PropTypes.string,
	hasLoadingText: PropTypes.string,
};

export default withTranslation()(LoadingIndicator);

